import { render, staticRenderFns } from "./ChangeToken.vue?vue&type=template&id=5864c39c&scoped=true"
import script from "./ChangeToken.vue?vue&type=script&lang=js"
export * from "./ChangeToken.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5864c39c",
  null
  
)

export default component.exports